import { isAnsweredShareCard, isRetiredReceipt } from "$lib/components/message/system-message.js";
import { withoutFailureEcho } from "./failure-history.js";
import { isHeldPrompt } from "./held-prompt.js";
import type { StreamEntry } from "./state.svelte.js";
import { withoutUsageLimitRepeats } from "./usage-limit-repeats.js";

// The rows a conversation draws: without repeated usage-limit notices, failure echoes and retired saved-item receipts and answered share cards, nor a prompt the agent holds (the queue bar lists it). The stream and its docked now row share it.
export function renderedStreamEntries(entries: readonly StreamEntry[]): readonly StreamEntry[] {
  return withoutFailureEcho(withoutUsageLimitRepeats(entries)).filter(
    (e) =>
      !("card" in e && (isRetiredReceipt(e) || isAnsweredShareCard(e))) &&
      !(e.kind === "user_message" && isHeldPrompt(e)),
  );
}
